import React from 'react';

const FacebookOAuthButton = ({ className = "", disabled = false }) => {
  const handleFacebookLogin = () => {
    const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
    const redirectUri = `http://localhost:5000/api/auth/facebook/callback`;
    
    // Facebook OAuth URL with required parameters
    const facebookOAuthUrl = `https://www.facebook.com/v18.0/dialog/oauth?` +
      `client_id=${facebookAppId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=email,public_profile` +
      `&response_type=code` +
      `&state=${Math.random().toString(36).substring(7)}`;

    // Redirect to Facebook OAuth
    window.location.href = facebookOAuthUrl;
  };

  return (
    <button
      type="button"
      onClick={handleFacebookLogin}
      disabled={disabled}
      className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <span className="absolute left-0 inset-y-0 flex items-center pl-3">
        <svg className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      </span>
      Continue with Facebook
    </button>
  );
};

export default FacebookOAuthButton;